import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {map, filter, sum} from 'lodash'
import CustomVotingForm from './custom_voting_form.jsx'
import {makeStyles} from '@material-ui/core/styles';
import {VelocityTransitionGroup} from 'velocity-react';
import 'velocity-animate/velocity.ui';
import useTranslation from "../../../../../shared/virtual_congress/effects/use_translation";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

});

// // This is for countdown not the whole bet is rerendered
// const CustomBetQuestion = ({bet, setQuestionDisabled}) => {
//   const [countdownTime, setCountdownTime] = useState(20)
//   const showBetResults =  bet.show_results
//
//   useEffect(() => {
//     if (countdownTime > 0) {
//       const timer = setInterval(() => setCountdownTime(countdownTime - 1), 1000);
//       return () => clearInterval(timer);
//     } else {
//       setQuestionDisabled(true)
//     }
//   }, [countdownTime]);
//
//   return <>
//     {bet.title.trim()}
//     {!showBetResults && countdownTime > 0  && <>
//       <br />
//       <div className="countdown-container">
//         {countdownTime} Sekunden
//       </div>
//     </>
//     }
//   </>
// }

const CustomBet = ({event, bettings, bet, locale}) => {
  // const [questionDisabled, setQuestionDisabled] = useState(false)
  let betting = bettings.find((betting) => betting.bet_id == bet.id)
  let maximum = sum(Object.values(bet.answer_stats))
  let answers = map(bet.answer_stats, (amount, title) => {
    return {
      name: title,
      value: maximum > 0 ? +((amount / maximum) * 100).toFixed(2) : +(100 / Object.keys(bet.answer_stats).length).toFixed(2)
    }
  })

  return <div className="row custom-voting-row">
    <div className="col">
      <div className="row">
        <div className="col-12 header-col">
          {/*<div className="header-box-container-1"/>*/}
          {/*<div className="header-box-container-2"/>*/}
          {/*<h5 className={"bet-title"}>*/}
          {/*  <CustomBetQuestion setQuestionDisabled={setQuestionDisabled} bet={bet}/>*/}
          {/*</h5>*/}
          <div className="bet-question">
            {bet.title}
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12">
          <CustomVotingForm event={event} betting={betting}  bet={bet} questionDisabled={false}/>
        </div>
      </div>
    </div>
  </div>
}

export default function CustomVoting({videoRoom, event, locale, ...props}) {
  const classes = useStyles();
  const bets = useSelector(state => state.bets)
  const bettings = useSelector(state => state.bettings)

  return <div className="container-fluid custom-voting-container">
    <div className="row justify-content-center">
      <div className="col-10">
        <VelocityTransitionGroup component="div" enter={{animation: "slideDown"}} leave={{animation: "slideUp"}}>
          {_.map(filter(bets, (bet, betId) => bet.result_chart_type == "custom1" && bet.visible && !bet.archived && bet.event_id == event.id), (bet, betId) => {
            return <CustomBet bet={bet} bettings={bettings} event={event}/>
          })}
        </VelocityTransitionGroup>
      </div>
    </div>
  </div>
}
